// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import ChatbotIllustration from "../../assets/chatbot-illustration.jpg";
// import { login } from "../../services/authService";

// export default function LoginPage() {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError("");

//     try {
//       // Panggil service login
//       // Token otomatis disimpan di localStorage oleh authService.js
//       await login({ email, password });

//       // <--- 3. Perintah pindah halaman
//       console.log("Login sukses, mengalihkan ke Dashboard...");
//       navigate("/dashboard"); 
      
//     } catch (err) {
//       console.error(err);
//       // Tampilkan error dari backend kalau ada
//       setError(err.response?.data?.error || "Login failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen flex relative">
//       {/* Left Side (Branding) */}
//       <div className="hidden md:flex w-1/2 bg-gradient-to-br from-indigo-500 to-purple-600 relative items-center justify-center text-text-pri p-10 overflow-hidden">
//        <div className="max-w-md space-y-6 z-10">
//         <h1 className="text-4xl font-bold leading-tight">
//           Bukan cuma HR admin, tapi{" "}
//           <span className="text-yellow-300">HR intelligence</span>.
//         </h1>
//         <h2 className="text-xl font-semibold mt-2 text-yellow-200">
//           Ubah data karyawan jadi keputusan people yang tepat
//         </h2>
//         <p className="text-lg opacity-90 leading-relaxed">
//           AI HR Agent kami nggak cuma jawab pertanyaan karyawan 24/7
//           soal cuti, payroll, dan kebijakan,
//           tapi juga jadi{" "}
//           <span className="font-semibold">radar kondisi organisasi</span>.
//         </p>
//       </div>
//         <div className="absolute top-10 left-10 w-32 h-32 rounded-full bg-yellow-300 opacity-20"></div>
//         <div className="absolute bottom-20 right-20 w-48 h-48 rounded-full bg-purple-400 opacity-20"></div>
//         <div
//           className="absolute bottom-10 left-20 w-64 h-64 bg-contain bg-no-repeat opacity-30"
//           style={{ backgroundImage: `url(${ChatbotIllustration})` }}
//         ></div>
//       </div>

//       {/* Right Side (Login Form) */}
//       <div className="flex w-full md:w-1/2 items-center justify-center p-8">
//         <div className="w-full max-w-md">
//           <h2 className="text-3xl font-bold mb-2 text-gray-800">Login</h2>
//           <p className="text-sm text-gray-500 mb-6">
//             Selamat datang kembali! Silakan masuk ke akun Anda.
//           </p>

//           <form className="space-y-5" onSubmit={handleSubmit}>
//             {error && (
//               <div className="p-3 bg-red-50 text-red-600 text-sm rounded-lg border border-red-200">
//                 {error}
//               </div>
//             )}

//             <div>
//               <label className="block text-sm font-medium text-gray-700">Email</label>
//               <input
//                 type="email"
//                 className="mt-1 w-full px-4 py-2 border rounded-xl focus:ring-2 focus:ring-indigo-500 focus:outline-none"
//                 placeholder="you@example.com"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 required
//               />
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700">Password</label>
//               <input
//                 type="password"
//                 className="mt-1 w-full px-4 py-2 border rounded-xl focus:ring-2 focus:ring-indigo-500 focus:outline-none"
//                 placeholder="••••••••"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//               />
//             </div>

//             <button
//               type="submit"
//               disabled={loading}
//               className="w-full py-3 px-4 bg-indigo-600 text-text-pri rounded-xl font-semibold hover:bg-indigo-700 transition disabled:opacity-50 shadow-md"
//             >
//               {loading ? "Verifying..." : "Sign In"}
//             </button>
//           </form>

//            {/* Link ke Sign Up (Opsional, biar gampang navigasi) */}
//            <div className="mt-6 text-center text-sm text-gray-600">
//             Belum punya akun?{" "}
//             <a href="/signup" className="text-indigo-600 font-semibold hover:underline">
//               Daftar di sini
//             </a>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// // Versi 2 - Simple
// import React, { useState, useEffect } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import { login } from "../../services/authService";
// import { EnvelopeIcon, LockClosedIcon, ArrowRightIcon } from "@heroicons/react/24/outline";

// export default function LoginPage() {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError("");

//     try {
//       await login({ email, password });
//       navigate("/dashboard"); 
//     } catch (err) {
//       console.error(err);
//       setError(err.response?.data?.error || "Login failed. Please check your credentials.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       {/* INJECT FONT */}
//       <style>
//         {`@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
//           .font-jakarta { font-family: 'Plus Jakarta Sans', sans-serif; }`}
//       </style>

//       <div className="font-jakarta min-h-screen bg-brand text-text-pri flex items-center justify-center relative overflow-hidden p-4">
        
//         {/* --- BACKGROUND AMBIANCE --- */}
//         <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0">
//           <div className="absolute top-[-10%] right-[20%] w-[500px] h-[500px] bg-indigo-600/20 rounded-full mix-blend-screen filter blur-[120px] animate-pulse duration-[8s]"></div>
//           <div className="absolute bottom-[-10%] left-[20%] w-[500px] h-[500px] bg-blue-600/20 rounded-full mix-blend-screen filter blur-[120px] animate-pulse delay-1000 duration-[10s]"></div>
//         </div>

//         {/* --- FLOATING CARD --- */}
//         <div className="z-10 w-full max-w-4xl bg-white backdrop-blur-xl border border-ledger-border rounded-3xl shadow-2xl flex flex-col md:flex-row overflow-hidden relative">
          
//           {/* ORNAMENT: Glow Effect */}
//           <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-blue-500/30 rounded-full blur-3xl pointer-events-none"></div>

//           {/* 1. LEFT SIDE: BRANDING VISUAL */}
//           <div className="hidden md:flex w-5/12 bg-gradient-to-br from-slate-900/80 to-indigo-900/80 p-10 flex-col justify-between border-r border-white/5 relative overflow-hidden">
//             {/* Abstract Pattern Overlay */}
//             <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
            
//             <div className="relative z-10">
//               <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/20 border border-indigo-400/30 text-indigo-300 text-[10px] font-bold uppercase tracking-widest mb-6">
//                  ✨ Enterprise Ready
//               </div>
//               <h2 className="text-3xl font-extrabold leading-tight mb-4 text-text-pri">
//                 Welcome <br/> Back, <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400">Pioneer.</span>
//               </h2>
//               <p className="text-text-sec text-sm leading-relaxed">
//                 Tax, Administration &amp; Compliance Integrated Assistance
//               </p>
//             </div>
            
//             <div className="relative z-10">
//                <div className="p-4 rounded-xl bg-white border border-ledger-border backdrop-blur-sm">
//                   <TaxFactRotator />
//                   <div className="flex items-center gap-2">
//                     <div className="w-6 h-6 rounded-full bg-indigo-500 flex items-center justify-center text-[10px] font-bold">??</div>
//                     <span className="text-[10px] font-bold text-text-sec">Tax Knowledge</span>
//                   </div>
//                </div>
//             </div>
//           </div>

//           {/* 2. RIGHT SIDE: LOGIN FORM */}
//           <div className="w-full md:w-7/12 p-8 md:p-12 bg-white text-text-pri relative">
//             <div className="flex justify-between items-start mb-10">
//               <div>
//                 <h3 className="text-2xl font-bold text-text-pri">Sign In</h3>
//                 <p className="text-text-sec text-sm mt-1">Enter your credentials to continue.</p>
//               </div>
//               {/* Logo Kecil */}
//               <div className="h-8 w-8 bg-brand rounded-lg flex items-center justify-center text-text-pri font-bold text-xs shadow-lg">WD</div>
//             </div>

//             <form onSubmit={handleSubmit} className="space-y-6">
//               {error && (
//                 <div className="p-3 bg-red-50 text-red-600 text-sm rounded-lg border border-red-200 flex items-center gap-2 animate-pulse">
//                   <ExclamationCircleIcon className="w-4 h-4" /> {error}
//                 </div>
//               )}

//               {/* INPUT: EMAIL */}
//               <div className="space-y-1">
//                 <label className="text-xs font-bold text-text-sec uppercase tracking-wide ml-1">Work Email</label>
//                 <div className="relative group">
//                   <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                     <EnvelopeIcon className="h-5 w-5 text-text-sec group-focus-within:text-indigo-600 transition" />
//                   </div>
//                   <input
//                     type="email"
//                     className="w-full pl-10 pr-4 py-3 bg-white border border-ledger-border rounded-xl focus:ring-2 focus:ring-indigo-100 focus:border-indigo-600 transition outline-none text-sm font-medium text-slate-800"
//                     placeholder="name@company.com"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     required
//                   />
//                 </div>
//               </div>

//               {/* INPUT: PASSWORD */}
//               <div className="space-y-1">
//                 <div className="flex justify-between ml-1">
//                   <label className="text-xs font-bold text-text-sec uppercase tracking-wide">Password</label>
//                   <a href="#" className="text-xs font-semibold text-indigo-600 hover:text-indigo-800 hover:underline">Forgot?</a>
//                 </div>
//                 <div className="relative group">
//                   <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                     <LockClosedIcon className="h-5 w-5 text-text-sec group-focus-within:text-indigo-600 transition" />
//                   </div>
//                   <input
//                     type="password"
//                     className="w-full pl-10 pr-4 py-3 bg-white border border-ledger-border rounded-xl focus:ring-2 focus:ring-indigo-100 focus:border-indigo-600 transition outline-none text-sm font-medium text-slate-800"
//                     placeholder="••••••••"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     required
//                   />
//                 </div>
//               </div>

//               {/* SUBMIT BUTTON */}
//               <button
//                 type="submit"
//                 disabled={loading}
//                 className="w-full py-3.5 bg-brand text-text-pri rounded-xl font-bold text-sm hover:bg-blue-600 transition shadow-xl shadow-slate-900/10 flex items-center justify-center gap-2 group disabled:opacity-70"
//               >
//                 {loading ? "Verifying..." : "Access Dashboard"}
//                 {!loading && <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition" />}
//               </button>
//             </form>

//             <div className="mt-10 text-center">
//               <p className="text-sm text-text-sec">
//                 New to the platform?{" "}
//                 <Link to="/signup" className="text-indigo-600 font-bold hover:underline">
//                   Create Account
//                 </Link>
//               </p>
//             </div>

//             {/* COPYRIGHT */}
//             <div className="absolute bottom-4 left-0 w-full text-center">
//                <span className="text-[10px] text-text-sec font-medium">Secured by Wibi Digital Technology</span>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// // Icon Helper (Biar ga error)
// function ExclamationCircleIcon({className}) {
//   return (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className}>
//       <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z" clipRule="evenodd" />
//     </svg>
//   );
// }

// // Versi 3 - Medium
import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { login, forgotPassword } from "../../services/authService";
import { EnvelopeIcon, LockClosedIcon, ArrowRightIcon, EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";


const TaxFactRotator = () => {
  const facts = [
    "Direktorat Jenderal Pajak (DJP) adalah instansi Kemenkeu yang bertugas merumuskan dan melaksanakan kebijakan di bidang pajak.",
    "Surat Pemberitahuan (SPT) adalah dokumen yang digunakan Wajib Pajak untuk melaporkan penghitungan dan pembayaran pajak.",
    "Pajak Penghasilan (PPh) 21 dipotong atas penghasilan berupa gaji, upah, honorarium, tunjangan, dan pembayaran lain terkait pekerjaan.",
    "Coretax Administration System (CTAS) adalah sistem administrasi perpajakan terintegrasi terbaru dari DJP.",
    "E-Bupot Unifikasi adalah sistem administrasi yang digunakan untuk membuat Bukti Pemotongan dan pelaporan SPT Masa PPh secara terpadu.",
    "Faktur Pajak adalah bukti pungutan pajak yang dibuat oleh Pengusaha Kena Pajak (PKP) yang melakukan penyerahan BKP atau JKP."
  ];
  const [index, setIndex] = React.useState(0);
  const [fade, setFade] = React.useState(true);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % facts.length);
        setFade(true);
      }, 500);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  return (
    <p className={`text-xs text-text-sec italic mb-2 transition-opacity duration-500 ${fade ? 'opacity-100' : 'opacity-0'}`}>
      "{facts[index]}"
    </p>
  );
};

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Forgot Password Modal States
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotLoading, setForgotLoading] = useState(false);
  const [forgotMessage, setForgotMessage] = useState("");
  const [forgotError, setForgotError] = useState("");

  const navigate = useNavigate();

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setForgotLoading(true);
    setForgotError("");
    setForgotMessage("");

    try {
      const response = await forgotPassword(forgotEmail);
      setForgotMessage(response.message || "Jika email terdaftar, link reset password akan dikirim.");
    } catch (err) {
      console.error(err);
      setForgotError(err.response?.data?.message || "Gagal mengirim permintaan. Coba lagi.");
    } finally {
      setForgotLoading(false);
    }
  };

const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await login({ email, password });
      if (response && response.user) {
         localStorage.setItem("user", JSON.stringify(response.user));
      }
      
      navigate("/dashboard"); 
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || "Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* INJECT FONT & ANIMATION */}
      {/* INJECT FONT & ANIMATION */}
      <style>
        {`@keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .animate-fadeIn {
            animation: fadeIn 0.5s ease-out forwards;
          }
        `}
      </style>

      <div className="font-sans min-h-screen bg-brand text-text-pri flex items-center justify-center relative overflow-hidden p-4">
        
        {/* --- BACKGROUND AMBIANCE --- */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0">
          <div className="absolute top-[-10%] right-[20%] w-[500px] h-[500px] bg-brand/20 rounded-full mix-blend-screen filter blur-[120px] animate-pulse duration-[8s]"></div>
          <div className="absolute bottom-[-10%] left-[20%] w-[500px] h-[500px] bg-brand/30 rounded-full mix-blend-screen filter blur-[120px] animate-pulse delay-1000 duration-[10s]"></div>
        </div>

        {/* --- FLOATING CARD (SAMAIN UKURAN & TAMBAH ANIMASI) --- */}
        {/* UBAH max-w-4xl JADI max-w-5xl BIAR SAMA KAYAK SIGN UP */}
        <div className="z-10 w-full max-w-5xl bg-card-bg backdrop-blur-xl border border-ledger-border rounded-3xl shadow-2xl flex flex-col md:flex-row overflow-hidden relative animate-fadeIn opacity-0">
          
          {/* ORNAMENT */}
          <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-brand/30 rounded-full blur-3xl pointer-events-none"></div>

          {/* 1. LEFT SIDE */}
          <div className="hidden md:flex w-5/12 bg-paper p-10 flex-col justify-between border-r border-white/5 relative overflow-hidden">
            <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
            
            <div className="relative z-10">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-low border border-brand/30 text-brand text-[10px] font-bold uppercase tracking-widest mb-6">
                Enterprise Ready
              </div>
              <h2 className="text-3xl font-extrabold leading-tight mb-4 text-text-pri">
                Welcome to <br/><span className="text-transparent bg-clip-text bg-gradient-to-r from-brand to-blue-500">TACIA.</span>
              </h2>
              <p className="text-text-sec text-sm leading-relaxed">
                Tax, Administration &amp; Compliance Integrated Assistance
              </p>
            </div>
            
            <div className="relative z-10">
               <div className="p-4 rounded-xl bg-card-bg border border-ledger-border backdrop-blur-sm">
                  <TaxFactRotator />
                  <div className="flex items-center gap-2">
                    <div className="w-6 h-6 rounded-full bg-brand flex items-center justify-center text-[10px] font-bold text-white">??</div>
                    <span className="text-[10px] font-bold text-text-sec">Tax Knowledge</span>
                  </div>
               </div>
            </div>
          </div>

          {/* 2. RIGHT SIDE */}
          <div className="w-full md:w-7/12 p-8 md:p-12 bg-card-bg text-text-pri relative">
            <div className="flex justify-between items-start mb-10">
              <div>
                <h3 className="text-2xl font-bold text-text-pri">Sign In</h3>
                <p className="text-text-sec text-sm mt-1">Enter your credentials to continue.</p>
              </div>
              <img src="/tacia-icon.png" alt="Tacia Logo" className="h-10 w-10 object-contain drop-shadow-md" />
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              {error && (
                <div className="p-3 bg-red-50 text-red-600 text-sm rounded-lg border border-red-200 flex items-center gap-2 animate-pulse">
                  <ExclamationCircleIcon className="w-4 h-4" /> {error}
                </div>
              )}

              {/* Form Inputs... (Sama seperti sebelumnya) */}
              <div className="space-y-1">
                <label className="text-xs font-bold text-text-sec uppercase tracking-wide ml-1">Work Email</label>
                <div className="relative group">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <EnvelopeIcon className="h-5 w-5 text-text-sec group-focus-within:text-brand transition" />
                  </div>
                  <input type="email" className="w-full pl-10 pr-4 py-3 bg-input-bg border border-ledger-border rounded-xl focus:ring-2 focus:ring-brand/20 focus:border-brand transition outline-none text-sm font-medium text-text-pri shadow-sm" placeholder="name@company.com" value={email} onChange={(e) => setEmail(e.target.value)} required />
                </div>
              </div>
              <div className="space-y-1">
                <div className="flex justify-between ml-1">
                  <label className="text-xs font-bold text-text-sec uppercase tracking-wide">Password</label>
                  <button type="button" onClick={() => { setShowForgotModal(true); setForgotEmail(""); setForgotMessage(""); setForgotError(""); }} className="text-xs font-semibold text-brand hover:text-blue-800 hover:underline">Forgot?</button>
                </div>
                <div className="relative group">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <LockClosedIcon className="h-5 w-5 text-text-sec group-focus-within:text-brand transition" />
                  </div>
                  <input
                    type={showPassword ? "text" : "password"}
                    className="w-full pl-10 pr-10 py-3 bg-input-bg border border-ledger-border rounded-xl focus:ring-2 focus:ring-brand/20 focus:border-brand transition outline-none text-sm font-medium text-text-pri shadow-sm"
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-text-sec hover:text-brand transition focus:outline-none"
                    title={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? (
                      <EyeSlashIcon className="h-5 w-5" />
                    ) : (
                      <EyeIcon className="h-5 w-5" />
                    )}
                  </button>
                </div>
              </div>

              <button type="submit" disabled={loading} className="w-full py-3.5 bg-brand text-white rounded-xl font-bold text-sm hover:bg-blue-600 transition shadow-xl shadow-brand/20 flex items-center justify-center gap-2 group disabled:opacity-70">
                {loading ? "Verifying..." : "Access Dashboard"}
                {!loading && <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition" />}
              </button>
            </form>

            <div className="mt-10 text-center">
              <p className="text-sm text-text-sec">
                New to the platform?{" "}
                <Link to="/signup" className="text-brand font-bold hover:underline">
                  Create Account
                </Link>
              </p>
            </div>
            
            <div className="absolute bottom-4 left-0 w-full text-center">
               <span className="text-[10px] text-text-sec font-medium">Secured by Wibi Digital Technology</span>
            </div>
          </div>
        </div>

        {/* === FORGOT PASSWORD MODAL === */}
        {showForgotModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4" onClick={() => setShowForgotModal(false)}>
            <div className="bg-card-bg rounded-2xl shadow-2xl w-full max-w-md p-8 relative animate-fadeIn border border-ledger-border" onClick={(e) => e.stopPropagation()}>
              {/* Close Button */}
              <button
                onClick={() => setShowForgotModal(false)}
                className="absolute top-4 right-4 text-text-sec hover:text-slate-600 transition"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>

              <div className="mb-6">
                <h3 className="text-xl font-bold text-text-pri">Reset Password</h3>
                <p className="text-text-sec text-sm mt-1">Masukkan email Anda, kami akan mengirim link reset password.</p>
              </div>

              <form onSubmit={handleForgotPassword} className="space-y-4">
                {forgotError && (
                  <div className="p-3 bg-red-50 text-red-600 text-sm rounded-lg border border-red-200">
                    {forgotError}
                  </div>
                )}
                {forgotMessage && (
                  <div className="p-3 bg-green-50 text-green-700 text-sm rounded-lg border border-green-200">
                    {forgotMessage}
                  </div>
                )}

                <div className="relative group">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <EnvelopeIcon className="h-5 w-5 text-text-sec group-focus-within:text-brand transition" />
                  </div>
                  <input
                    type="email"
                    className="w-full pl-10 pr-4 py-3 bg-input-bg border border-ledger-border rounded-xl focus:ring-2 focus:ring-brand/20 focus:border-brand transition outline-none text-sm font-medium text-text-pri"
                    placeholder="name@company.com"
                    value={forgotEmail}
                    onChange={(e) => setForgotEmail(e.target.value)}
                    required
                    autoFocus
                  />
                </div>

                <button
                  type="submit"
                  disabled={forgotLoading}
                  className="w-full py-3 bg-brand text-white rounded-xl font-bold text-sm hover:bg-blue-600 transition shadow-lg disabled:opacity-70"
                >
                  {forgotLoading ? "Mengirim..." : "Kirim Link Reset"}
                </button>
              </form>

              <div className="mt-4 text-center">
                <button
                  onClick={() => setShowForgotModal(false)}
                  className="text-sm text-text-sec hover:text-indigo-600 transition"
                >
                  Kembali ke Login
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

function ExclamationCircleIcon({className}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z" clipRule="evenodd" />
    </svg>
  );
}